import { FC, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';

import { IPsyBlock } from '../new-questions/new-question-psy';

import { GrowPanel } from './grow-panel';

export interface GrowPsyProps extends IPsyBlock {
  /** Снять выбор инструмента в панели (закрытие крестиком) */
  onClosePanel?: () => void;
}

/** Плавающее окно поверх видеокомнаты (не в колонке инструментов), перенос в `document.body` для `position: fixed`. */
export const GrowPsy: FC<GrowPsyProps> = ({ onToolActivated, onClosePanel }) => {
  const launchedRef = useRef(false);

  useEffect(() => {
    if (launchedRef.current || !onToolActivated) return;
    launchedRef.current = true;
    onToolActivated('grow_ai', {});
  }, [onToolActivated]);

  return createPortal(
    <GrowPanel
      embedded={false}
      onRequestClose={() => {
        onClosePanel?.();
      }}
    />,
    document.body,
  );
};
